// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"Block-module--imgWrapper--3jyss","blockDescription":"Block-module--blockDescription--2ub9r","blockWrapper":"Block-module--blockWrapper--OCmuL"};